import { takeLatest, put, select } from "redux-saga/effects";
import { ApiCall } from "../api";
import {
  LDD_GETLISTA_COMPLETE,
  LDD_GETLISTA_START,
  NOT_LOADING_COMPLETE,
} from "../../const/actionTypes";
import { getLdDFecha } from "../selectors";
// import { addMinutes } from "date-fns";
import { jwtDecode } from "jwt-decode";

export function* GetLdD({ payload }) {
  const p = {
    ...payload,
  };

  const token = {
    ...jwtDecode(p.Token),
  };
  if (
    token &&
    token.conductor &&
    (token.conductorsol === "0" ||
      token.conductor.toString() === p.Conductor.toString())
  ) {
    yield put({ type: NOT_LOADING_COMPLETE, payload: true });

    const fecha = yield select(getLdDFecha);

    const ldd = yield ApiCall(
      p.Ec
        ? "/api/Conductores/ObtenerListaDisponibilidadCond"
        : "/api/Conductores/ObtenerListaDisponibilidad",
      "POST",
      JSON.stringify(
        p.Ec
          ? {
              Fecha: fecha,
              Conductor: p.Conductor,
              Token: p.Token,
            }
          : {
              Fecha: fecha,
              Token: p.Token,
            }
      ),
      p.Token
    );
    if (ldd) {
      const f =
        (ldd.Results &&
          ldd.Results.length > 0 &&
          new Date(ldd.Results[0].FECHA_GENERACION)) ||
        fecha;
      yield put({
        type: LDD_GETLISTA_COMPLETE,
        payload: { fecha: f, listado: ldd.Results },
      });

      yield put({ type: NOT_LOADING_COMPLETE, payload: false });
    }
  }
}

export default function* lista() {
  yield takeLatest(LDD_GETLISTA_START, GetLdD);
}
